import React, { useState, useEffect } from 'react';
import CloseIcon from '../../../assets/icons/CloseIcon';
import Label from '../Label';

import styles from "./index.module.scss"

function RcmpAlert(props) {
    const { children, cType, bIsOpen, fnCloseAlert, className, ...oRest } = props;

    const [bShowAlert, fnSetBshowAlert] = useState(bIsOpen)

    useEffect(() => {
        fnSetBshowAlert(bIsOpen)
    }, [bIsOpen])

    const cClass = `${styles.alert} ${styles[cType]} ${className ? className : ""}`

    function fnHandleOnCloseAlert() {
        fnSetBshowAlert(false)
        fnCloseAlert?.()
    }

    if (!bShowAlert) return null

    return (
        <div className={cClass} {...oRest}>
            <Label>{children}</Label>
            <button type="button" className={styles.close} onClick={fnHandleOnCloseAlert}>
                <CloseIcon />
            </button>
        </div>
    )
}

export default RcmpAlert;
